import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, } from "@mui/material";
import { forceLogout } from "components/axios/forceLogout";

// import { persistor } from "index";
// import { LOGOUT } from "store/reducers/auth";
// import { deleteUser } from "store/reducers/userSlice";
  
const LogoutPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    
    return (
        <Button 
            variant="contained" 
            onClick={() => forceLogout(dispatch, navigate)}
        >
            {t('header.logout')}
        </Button>
    )
}

export default LogoutPage;